import * as React from 'react';

import * as styles from './styles.css';

export const PaginationSentinel = React.forwardRef<HTMLDivElement>((props, ref) => {
  return <div ref={ref} className={styles['pagination-sentinel']} {...props} />;
});

PaginationSentinel.displayName = 'PaginationSentinel';
